var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoCreateAndChoosequestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.7,
    height: 135.852,
    viewBox: "0 0 147.7 135.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5082",
    "data-name": "Group 5082",
    transform: "translate(-888 -618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5081",
    "data-name": "Group 5081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4531",
    "data-name": "Group 4531",
    transform: "translate(888 618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4250",
    "data-name": "Rectangle 4250",
    fill: "#eef3ff",
    stroke: "#92b0ff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 39,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 145,
    height: 38,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3443",
    "data-name": "Path 3443",
    transform: "translate(38.763 6.202)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 98.73379516601562 25.85897636413574 L 0.4999975860118866 25.85897636413574 L 0.4999975860118866 0.5000006556510925 L 98.73379516601562 0.5000006556510925 L 98.73379516601562 25.85897636413574 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.000007629394531 0.9999942779541016 L 1.000007629394531 25.35898208618164 L 98.23378753662109 25.35898208618164 L 98.23378753662109 0.9999942779541016 L 1.000007629394531 0.9999942779541016 M 7.62939453125e-06 -5.7220458984375e-06 L 99.23378753662109 -5.7220458984375e-06 L 99.23378753662109 26.35898208618164 L 7.62939453125e-06 26.35898208618164 L 7.62939453125e-06 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "#b2c6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4530",
    "data-name": "Group 4530",
    transform: "translate(13.179 2.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(5.82 26.674)",
    fill: "#91aefc",
    fontSize: 26,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.322,
    y: 0
  }, "?"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4532",
    "data-name": "Group 4532",
    transform: "translate(888 661.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4250-2",
    "data-name": "Rectangle 4250",
    transform: "translate(0 -0.415)",
    fill: "#eef3ff",
    stroke: "#92b0ff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 39,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 145,
    height: 38,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3443-2",
    "data-name": "Path 3443",
    transform: "translate(38.763 6.202)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 98.73379516601562 25.85897636413574 L 0.4999975860118866 25.85897636413574 L 0.4999975860118866 0.5000006556510925 L 98.73379516601562 0.5000006556510925 L 98.73379516601562 25.85897636413574 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.000007629394531 0.9999942779541016 L 1.000007629394531 25.35898208618164 L 98.23378753662109 25.35898208618164 L 98.23378753662109 0.9999942779541016 L 1.000007629394531 0.9999942779541016 M 7.62939453125e-06 -5.7220458984375e-06 L 99.23378753662109 -5.7220458984375e-06 L 99.23378753662109 26.35898208618164 L 7.62939453125e-06 26.35898208618164 L 7.62939453125e-06 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "#b2c6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4530-2",
    "data-name": "Group 4530",
    transform: "translate(13.179 2.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4517-2",
    "data-name": "Group 4517",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "?",
    transform: "translate(5.82 27.26)",
    fill: "#91aefc",
    fontSize: 26,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.322,
    y: 0
  }, "?"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4533",
    "data-name": "Group 4533",
    transform: "translate(888 704.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4250-3",
    "data-name": "Rectangle 4250",
    transform: "translate(0 0.171)",
    fill: "#eef3ff",
    stroke: "#92b0ff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 39,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 145,
    height: 38,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3443-3",
    "data-name": "Path 3443",
    transform: "translate(38.763 6.202)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 98.73379516601562 25.85897636413574 L 0.4999975860118866 25.85897636413574 L 0.4999975860118866 0.5000006556510925 L 98.73379516601562 0.5000006556510925 L 98.73379516601562 25.85897636413574 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.000007629394531 0.9999942779541016 L 1.000007629394531 25.35898208618164 L 98.23378753662109 25.35898208618164 L 98.23378753662109 0.9999942779541016 L 1.000007629394531 0.9999942779541016 M 7.62939453125e-06 -5.7220458984375e-06 L 99.23378753662109 -5.7220458984375e-06 L 99.23378753662109 26.35898208618164 L 7.62939453125e-06 26.35898208618164 L 7.62939453125e-06 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "#b2c6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4530-3",
    "data-name": "Group 4530",
    transform: "translate(13.179 2.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4517-3",
    "data-name": "Group 4517",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": "?",
    transform: "translate(5.82 26.845)",
    fill: "#91aefc",
    fontSize: 26,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.322,
    y: 0
  }, "?")))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542",
    transform: "translate(1011.815 730.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3444",
    "data-name": "Path 3444",
    d: "M493.209,507.443a2.34,2.34,0,0,1-1.71-.695l-8.926-8.926-3.367,3.367a2.092,2.092,0,0,1-2.191.481,2.022,2.022,0,0,1-1.283-1.817l-.481-15.66,15.767.428a2.038,2.038,0,0,1,1.871,1.283,2.073,2.073,0,0,1-.428,2.191l-3.367,3.367,8.872,8.819a2.254,2.254,0,0,1,.641,1.924,3.15,3.15,0,0,1-.962,1.978l-2.3,2.3A2.934,2.934,0,0,1,493.209,507.443Zm-10.636-11.171L492.247,506a1.659,1.659,0,0,0,2.352-.267l2.3-2.3a2.11,2.11,0,0,0,.641-1.283,1.268,1.268,0,0,0-.374-1.069l-9.674-9.728,4.116-4.116a.982.982,0,0,0,.214-1.069,1.062,1.062,0,0,0-.855-.641l-14.645-.374.428,14.592a.867.867,0,0,0,.641.855,1,1,0,0,0,1.069-.214Z",
    transform: "translate(-475.25 -484.193)",
    fill: "#91aefc",
    stroke: "#91aefc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4536",
    "data-name": "Group 4536",
    transform: "translate(1011.923 720)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    "data-name": "Path 3445",
    d: "M478.339,247.973a.5.5,0,0,1-.534-.534V243.27a.534.534,0,1,1,1.069,0v4.222A.494.494,0,0,1,478.339,247.973Z",
    transform: "translate(-477.805 -242.735)",
    fill: "#91aefc",
    stroke: "#91aefc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4537",
    "data-name": "Group 4537",
    transform: "translate(1015.824 722.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    "data-name": "Path 3446",
    d: "M571.6,313.23a.485.485,0,0,1-.374-.16.517.517,0,0,1,0-.748l2.993-2.993a.529.529,0,1,1,.748.748l-2.993,2.993A.485.485,0,0,1,571.6,313.23Z",
    transform: "translate(-571.066 -309.168)",
    fill: "#91aefc",
    stroke: "#91aefc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4538",
    "data-name": "Group 4538",
    transform: "translate(1005.188 733.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3447",
    "data-name": "Path 3447",
    d: "M317.368,571.3a.485.485,0,0,1-.374-.16.517.517,0,0,1,0-.748l2.993-2.993a.529.529,0,0,1,.748.748l-2.993,2.993A.577.577,0,0,1,317.368,571.3Z",
    transform: "translate(-316.833 -567.234)",
    fill: "#91aefc",
    stroke: "#91aefc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4539",
    "data-name": "Group 4539",
    transform: "translate(1002.248 729.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    "data-name": "Path 3448",
    d: "M251.325,476.319H247.1a.534.534,0,0,1,0-1.069h4.222a.534.534,0,1,1,0,1.069Z",
    transform: "translate(-246.568 -475.25)",
    fill: "#91aefc",
    stroke: "#91aefc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540",
    transform: "translate(1003.157 720.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3449",
    "data-name": "Path 3449",
    d: "M273.738,270.44a.485.485,0,0,1-.374-.16l-4.917-4.917a.529.529,0,0,1,.748-.748l4.917,4.917a.517.517,0,0,1,0,.748A.577.577,0,0,1,273.738,270.44Z",
    transform: "translate(-268.286 -264.454)",
    fill: "#91aefc",
    stroke: "#91aefc",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCreateAndChoosequestion);
export default __webpack_public_path__ + "static/media/NoCreateAndChoosequestion.d3ba8811a127c29288e2bed6e7739fca.svg";
export { ForwardRef as ReactComponent };